import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/styles';
import Divider from '@material-ui/core/Divider';

import withRoot from '../../styles/withRoot';
import Snackbar from '../../components/labels/Snackbar';
import { BlueCloseIcon, BlueTickIcon } from '../../images/icons/WrapSvg';

import { bindActionCreators } from 'redux';
import * as users from '../../actions/user.actions';
import * as sessions from '../../actions/session.actions';

const styles = (theme) => ({});

class Pin extends React.Component {
    state = {
        error: undefined,
        currentpassword: '',
        newpassword: '',
        confirmpassword: '',
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (e) => {
        this.props.history.goBack();
    };

    handleSummit = (event) => {
        const { currentpassword, newpassword } = this.state;
        const user = sessionStorage.user;
        this.props
            .loginUser(user, currentpassword)
            .then(() => {
                this.props
                    .changePin(user, newpassword)
                    .then((response) => this.props.history.goBack())
                    .catch((error) => this.setState({ error: error.message }));
            })
            .catch((error) => this.setState({ error: error.message }));
    };

    handleCloseError = () => {
        this.setState({ error: undefined });
    };

    isCorrect = () => {
        const { currentpassword, newpassword, confirmpassword } = this.state;
        return currentpassword && newpassword && confirmpassword && newpassword === confirmpassword;
    };

    render() {
        const { newpassword, confirmpassword, error } = this.state;
        const { intl } = this.props;
        return (
            <div className={'flex_full_column fullscreen'}>
                <div className={'flex_header'}>
                    <div className={'flex_full_row padding_borders'}>
                        <BlueCloseIcon
                            color="primary"
                            onClick={(e) => this.handleClose(e)}
                            className="margin_right_18"
                        />
                        <span className={'barlowsemicondensed_bold flex_full c_dark_grey_blue '}>
                            <FormattedMessage id="change_pin_title" />
                        </span>
                        {this.isCorrect() && (
                            <BlueTickIcon
                                color="primary"
                                className={'hand'}
                                onClick={this.handleSummit.bind(this)}
                            />
                        )}
                    </div>
                </div>
                <Divider />
                <div className={'flex_auto display_flex height100 align_center'}>
                    <Grid container justify="center" className={'text_align_center flex_grow_1'}>
                        <Grid item xs={10} sm={6}>
                            <TextField
                                fullWidth
                                id="currentpassword-input"
                                name="currentpassword"
                                label={intl.formatMessage({ id: 'change_pin_actual' })}
                                className={'padding_bottom_24 margin_top_9'}
                                type="password"
                                autoComplete="current-password"
                                margin="normal"
                                onChange={this.handleChange}
                            />
                            <TextField
                                fullWidth
                                id="newpassword-input"
                                name="newpassword"
                                label={intl.formatMessage({ id: 'change_pin_new' })}
                                className={'padding_bottom_24 margin_top_9'}
                                type="password"
                                margin="normal"
                                onChange={this.handleChange}
                            />
                            <TextField
                                fullWidth
                                id="confirmpassword-input"
                                name="confirmpassword"
                                label={intl.formatMessage({ id: 'change_pin_confirm' })}
                                className={'padding_bottom_24 margin_top_9'}
                                type="password"
                                margin="normal"
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>
                </div>
                {(error || (newpassword && confirmpassword && newpassword !== confirmpassword)) && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        message={'change_pin_error_no_match'}
                        onClose={this.handleCloseError}
                    />
                )}
            </div>
        );
    }
}

Pin.propTypes = {
    intl: intlShape.isRequired,
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, users, sessions), dispatch);
};

Pin = connect(
    null,
    mapDispatchToProps,
)(Pin);

Pin = withRouter(Pin);

Pin = injectIntl(Pin);

export default withRoot(withStyles(styles, { withTheme: true })(Pin));



// WEBPACK FOOTER //
// ./src/pages/knowhow/Pin.js